import WsService from "./WsService";
import BeneficiaryRequiredField from "../domain/BeneficiaryRequiredField";

const ENDPOINT_BASE = "/transactions/beneficiary-required-field";

export default class BeneficiaryRequiredFieldsService {

    static retrieveBeneficiaryRequiredFields(beneficiaryId) {

        let endpoint = ENDPOINT_BASE + "?beneficiary-id=" + beneficiaryId;
        return WsService.get(endpoint, {}, 200).then(
            response => {
                let array = [];
                response.forEach(jsonRequiredField => {
                    array.push(new BeneficiaryRequiredField(jsonRequiredField));
                });
                return array;
            },
            response => {
                return response;
            });
    }
}